var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-text"},[_c('h1',{staticClass:"display-text"},[_vm._v(_vm._s(_vm.name.first)+" "+_vm._s(_vm.name.last))]),_c('h2',{attrs:{"id":"typewriter"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }